<template>
<div class="row stage">
    <div v-if="!edit">
        <div class="col-md-3 name">
            <router-link tag="p" :to="{ name: 'projects.stage1.requirements', params: { 'project_id': project.id }}" v-if="stage.stage.id == 1"><i class="fa fa-microscope"></i> {{stage.stage.name}} (S{{stage.stage.id}})</router-link>
            <router-link tag="p" :to="{ name: 'projects.stage2.userstories', params: { 'project_id': project.id }}" v-if="stage.stage.id == 2"><i class="fa fa-microscope"></i> {{stage.stage.name}} (S{{stage.stage.id}})</router-link>
            <router-link tag="p" :to="{ name: 'projects.stage3.overview', params: { 'project_id': project.id }}" v-if="stage.stage.id == 3"><i class="fa fa-microscope"></i> {{stage.stage.name}} (S{{stage.stage.id}})</router-link>
            <dl>
                <dt>Status:</dt>
                <dd><span class="label label-primary" v-if="stage.status">{{ stage.status.name}}</span></dd>
            </dl>
        </div>
        <div class="col-md-3 text-right complete">
            <dl>
                <dt>Commenced:</dt>
                <dd>{{ stage.commenced | moment("DD MMM YYYY")}}</dd><br>
                <dt>Signed Off:</dt>
                <dd><span v-if="stage.completed">{{ stage.completed | moment("DD MMM YYYY")}}</span></dd>
            </dl>
        </div>

        <div class="col-md-3 text-right complete">
            <dl>
                <dt>Lead:</dt>
                <dd class="team-members"><a href="#" data-toggle="tooltip" :title="stage.lead.name" v-if="stage.lead"><img alt="member" class="img-circle" v-bind:src="getAvatar(stage.lead.id)"></a></dd>
                <dt>Members</dt>
                <dd class="team-members"><a href="#" v-bind:key="member.id" v-for="member in stage.members" data-toggle="tooltip" :title="member.name"><img alt="member" class="img-circle" v-bind:src="getAvatar(member.id)"></a></dd>
            </dl>
        </div>

        <div class="col-md-3 text-right actions">
            <i @click="edit = true" class="fa fa-pencil"></i>&nbsp;&nbsp;&nbsp;&nbsp;<i @click="confirmDelete()" class="fa fa-trash danger"></i>
        </div>
    </div>

    <div v-else>
        <div class="col-md-12">
            <div class="row">
                <div class="col-md-12">
                    <div class="col-md-3">
                        <h4>{{stage.stage.name}}</h4>
                    </div>
                </div>
            </div>

            <div class="row">
                 <div class="col-md-6">
                    <div class="form-group">
                        <label class="control-label col-md-4">Started:</label>
                        <div class="col-md-6">
                            <datepicker v-bind:value="stage.commenced" @input="selectedStartDate" input-class="form-control"></datepicker>
                        </div>
                    </div><!-- /.form-group -->
                </div>
                <div class="col-md-6">
                   <div class="form-group">
                        <label class="control-label col-md-4">Lead:</label>
                        <div class="col-md-6">
                            <multiselect v-model="stage.lead" :options="userOptions" label="name" track-by="id"></multiselect>
                        </div>
                    </div><!-- /.form-group -->
                </div>
            </div>

            <div class="row">
                <div class="col-md-6">
                     <div class="form-group">
                        <label class="control-label col-md-4">Signed Off:</label>
                        <div class="col-md-6">
                            <datepicker v-bind:value="stage.completed" @input="selectedEndDate" input-class="form-control"></datepicker>
                        </div>
                    </div><!-- /.form-group -->


                </div>
                <div class="col-md-6">
                     <div class="form-group">
                        <label class="control-label col-md-4">Members:</label>
                        <div class="col-md-6">
                            <multiselect v-model="stage.members" :options="userOptions" label="name" track-by="id" @select="userSelected" :multiple="true"></multiselect>
                        </div>
                    </div><!-- /.form-group -->

                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                     <div class="form-group">
                        <label class="control-label col-md-4">Status:</label>
                        <div class="col-md-6">
                            <multiselect v-model="stage.status" :options="statusList" label="name" track-by="id" @select="statusSelected"></multiselect>
                        </div>
                    </div><!-- /.form-group -->


                </div>
                <div class="col-md-6">
                    <ladda-button :on-click="save" class="btn float-right"><i class="fa fa-save"></i> Save</ladda-button>
                </div>
            </div>
        </div>




    </div>
</div>
</template>

<script>

    import { Selectize, LaddaButton } from 'components/form/input'
    import Datepicker from 'vuejs-datepicker'
    import { notify } from 'utils'
    import Multiselect from 'vue-multiselect'
    import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'

    export default {
         components: {
            Selectize,
            Datepicker,
            LaddaButton,
            Multiselect
        },

        props: [
            'project',
            'stage'
        ],

        data: function () {
            return {
                edit: false,
                users: [],
                selectedUsers: []
            }
        },

        mounted: function() {
            this.users = this.userOptions
        },
        created: function() {

        },
        computed: {
            ...mapGetters('user', ['userOptions']),
            ...mapGetters('status', ['stage1List', 'stage2List', 'stage3List']),

            statusList () {
                if (this.stage.stage.project_type_id == 1) {
                    return this.stage1List;
                }

                return this.stage3List;
            }
        },

        methods: {
            statusSelected(status) {
                this.stage.status_id = status.id
            },
            confirmDelete() {
                var that = this;

                this.$swal(
                    {
                        title: 'Confirm Delete',
                        html: 'Are you sure you want to delete stage '+this.stage.stage.name,
                        type: 'question',
                        showCancelButton: true,
                        confirmButtonText: 'Delete',
                    }).then(function() {
                        that.deleteStage();
                }, function() {
                });

            },
            save: function() {

                var that = this;

                return client({path: '/projects/'+this.project.id+'/stages/'+this.stage.id, entity: {'stage': this.stage, 'members':this.members}, method: 'PUT'}).then(
                    function(response) {
                       // that.stage.lead = response.entity.lead;
                        that.edit = false;
                    },
                    function(response) {

                        if (response.status.code == 422) {
                            var firstValidationIssue = response.entity[Object.keys(response.entity)[0]];

                        } else {

                        }
                    }

                )

            	this.edit = false;
            },
            deleteStage: function() {

                var that = this;

                return client({path: '/projects/'+this.project.id+'/stages/'+this.stage.id, entity: {'stage': this.stage}, method: 'DELETE'}).then(
                    function(response) {
                       // that.stage.lead = response.entity.lead;
                        that.edit = false;

                        //Remove stage from project list
                        var pro = that.$parent.projects.find(x => x.id === that.project.id);
                        var index = pro.stages.indexOf(that.stage);
                        pro.stages.splice(index, 1)
                    },
                    function(response) {

                        if (response.status.code == 422) {
                            var firstValidationIssue = response.entity[Object.keys(response.entity)[0]];

                        } else {

                        }
                    }

                )

            	this.edit = false;
            },
            selectedStartDate: function(e) {
                let d = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds()));
                this.stage.commenced = moment(d).format("YYYY-MM-DD")
            },
            selectedEndDate: function(e) {
                let d = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds()));
                this.stage.completed = moment(d).format("YYYY-MM-DD")
            },

        	getAvatar: function(id) {
        		return process.env.VUE_APP_API_URL + '/user/' + id + '/avatar';
        	}
        },

    }
</script>

<style scoped>

</style>
